import React from 'react';
import { motion } from 'framer-motion';
export function SolutionTeaser() {
  return <section className="py-12 px-6 md:px-12 bg-white border-y border-gold/10" data-id="element-76">
      <div className="max-w-4xl mx-auto text-center" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-78">
          <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-79">
            La Nueva Frontera Anti-Aging
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-8" data-id="element-80">
            El Protocolo de 15 Minutos
          </h2>
          <p className="text-lg md:text-xl font-sans font-light text-charcoal-light leading-relaxed max-w-2xl mx-auto" data-id="element-81">
            No se trata de masajes superficiales. Hablamos de una técnica
            precisa de{' '}
            <strong className="text-charcoal font-medium" data-id="element-82">
              estimulación del colágeno mediante micro-contracciones musculares
            </strong>
            . Un protocolo diario que reeduca la musculatura facial para
            revertir los signos del envejecimiento de forma natural y sostenida.
          </p>
        </motion.div>
      </div>
    </section>;
}